import { useRef, useState } from "react";
import { toast } from "sonner";
import { Scale } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { ReconcileTable } from "@/components/ReconcileTable";

export function ReconcileCheck() {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const [d, setD] = useState(null);
  const run = async (file) => {
    if (!file) return;
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); const { data } = await api.post("/performance/reconcile", fd); setD(data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <div className="pp-card p-4 mb-4" data-testid="reconcile-card">
      <div className="flex flex-wrap items-center gap-3">
        <Scale size={18} className="text-slate-600" />
        <div className="text-sm"><div className="font-semibold">Check an upload file against saved data</div><div className="text-xs text-slate-500">Pick the same Excel you uploaded — see Plan / Produced per date in the file vs PlantPulse, and exactly which rows were not saved and why. (This check also runs automatically after every upload.)</div></div>
        <input ref={ref} type="file" accept=".xlsx,.csv" className="hidden" onChange={(e) => run(e.target.files?.[0])} data-testid="reconcile-input" />
        <button type="button" className="pp-btn-ghost h-9 ml-auto" disabled={busy} onClick={() => ref.current?.click()} data-testid="reconcile-btn">{busy ? "Checking…" : "Choose file to compare"}</button>
      </div>
      {d && <div className="mt-3"><ReconcileTable d={d} /></div>}
    </div>
  );
}
